<template>
  <div class="tab-pane-inner">
    <div class="inspections-list form-inspection">
      <div class="popup-table-header">
        <h3>{{ $t("COMMON.ESTIMATES") }}</h3>
        <base-button class="add" icon size="sm" @click="addEstimate">
          <span class="btn-inner--icon">
            <i class="fa-regular fa-circle-plus"></i>
          </span>
          <span class="btn-inner--text">
            {{ $t("ESTIMATES.ADD_ESTIMATE") }}
          </span>
        </base-button>
      </div>
      <estimate-list-table
        :add-section="false"
        :columns="tableColumns"
        :filterVehicle="vehicle.id"
        :show-pagination="false"
        @onAddEstimate="addEstimate"
        @onDeleteEstimate="viewEstimate"
        @onEditEstimate="editEstimate"
        @onViewEstimate="viewEstimate"
        show-all
      />
    </div>
  </div>
</template>

<script>
import {
  QUERY_ACTIONS_ADD,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_VIEW,
} from "@/constants/common";
import EstimateListTable from "@/views/Pages/InspectproModule/EstimateManagement/partials/EstimateListTable.vue";
import CopyElement from "@/components/CopyElement.vue";
import VehicleRefStandardized from "@/components/VehicleRefStandardized.vue";

export default {
  name: "vehicle-view-estimates",

  components: { EstimateListTable, CopyElement, VehicleRefStandardized },

  props: ["vehicle"],

  data() {
    return {
      tableColumns: [
        // "vehicle",
        "vin",
        "customer",
        "model",
        "status",
        // "approver",
        "updated_at",
        // "days",
      ],
    };
  },

  computed: {},

  created() {},

  methods: {
    viewEstimate(estimate) {
      this.$router.push({
        name: "List Estimates",
        query: { id: estimate.id, action: QUERY_ACTIONS_VIEW },
      });
    },
    editEstimate(estimate) {
      this.$router.push({
        name: "List Estimates",
        query: { id: estimate.id, action: QUERY_ACTIONS_EDIT },
      });
    },
    addEstimate() {
      this.$router.push({
        name: "List Estimates",
        query: {
          action: QUERY_ACTIONS_ADD,
          vehicle_id: this.vehicle.id,
        },
      });
    },
  },

  mounted() {},

  watch: {
    vehicle(vehicle) {},
  },
};
</script>
